<template>
  <b-modal
    ref="createContactModal"
    size="xl"
    :title-html="`<i class=\'uil-user-plus mr-1\'></i> ${editMode ? 'Update Contact' : 'Create Contact' }`"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-light"
    static
    hide-footer
    hide-header-close
    >
    <form
      @submit.prevent="onSave">
      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
        {{errorMessage}}
      </div>

      <div class="row">
        <div class="col-sm-12 row">
          <div class="card-body">

            <div class="row">
              <div class="col-4">
                <TextField 
                  :placeholder="$t('user.form.first_name.placeholder')"
                  :label="$t('user.form.first_name.label')"
                  v-model="model.first_name"
                  :error="$v.model.first_name.$error"
                  :errorMessage="$v.model.first_name.errorMessage"
                />
              </div>

              <div class="col-4">
                <TextField 
                  :placeholder="$t('user.form.middle_name.placeholder')"
                  :label="$t('user.form.middle_name.label')"
                  v-model="model.middle_name"
                />
              </div>

              <div class="col-4">
                <TextField 
                  :placeholder="$t('user.form.last_name.placeholder')"
                  :label="$t('user.form.last_name.label')"
                  v-model="model.last_name"
                  :error="$v.model.last_name.$error"
                  :errorMessage="$v.model.last_name.errorMessage"
                />
              </div>
              <div class="col-4">
                <TextField 
                  placeholder="hello@hrtech.com"
                  :label="$t('user.form.email.label')"
                  type="email"
                  autocomplete="off"
                  v-model="model.email"
                  :error="$v.model.email.$error"
                  :errorMessage="$v.model.email.errorMessage"
                />
              </div>
              <div class="col-4">
                <DropDown 
                  :placeholder="$t('candidate.form.gender.placeholder')"
                  :label="$t('candidate.form.gender.label')"
                  :name.sync="model.gender"
                  v-model="model.gender"
                  :options="genderOption"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div>
      <div class="float-right">
        <button class="btn btn-dark btn-sm mr-2" @click="hide">Cancel</button>
        <Button class="btn btn-primary btn-sm" @click="onSave" :loading="loading">
          <i class='uil-user-plus mr-1'></i> {{editMode ? 'Update': 'Create'}}
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import { required, email} from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import Button from '@components/buttons/button'

export default {
  mixins: [FormMixin],
  components:{TextField, DropDown, Button},
  props:['company_id'],
  data(){
    return {
      model:{
        first_name: '',
        middle_name:'',
        last_name: '',
        email: '',
        gender: ''
      },
      genderOption: [
        {value: 'MALE', text: 'MALE'},
        {value: 'FEMALE', text: 'FEMALE'},
        {value: 'OTHER', text: 'OTHER'}
      ],
      editMode: false
    }
  },
  validations: {
    model:{
      first_name: { 
        required
      },
      last_name: { 
        required
      },
      email: {
        required,
        email
      },
      gender: {
        required
      }
    }
  },
  methods:{
    onView() {
      this.$router.push('/administration/user')
    },
    ...mapActions('company', ['createContactPerson', 'findContactPerson', 'editContactPerson']),
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this.model.company_id = this.company_id
      if(!this.editMode){
        this.createContactPerson(this.model)
        .then(()=> {
          this.toggleLoading()
          this.resetModel()
          this.$emit('refreshData')
          this.hide()
        })
        .catch((err) => {
          this.toggleLoading()

          Object.keys(err.response.data).forEach(key => {
            if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
          })

          this.setError(err.response.data.msg)
        })
      }else{
        this.editContactPerson(this.model)
        .then(()=> {
          this.toggleLoading()
          this.resetModel()
          this.$emit('refreshData')
          this.hide()
        })
        .catch((err) => {
          this.toggleLoading()

          Object.keys(err.response.data).forEach(key => {
            if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
          })

          this.setError(err.response.data.msg)
        })
      }
      
    },
    resetModel(){
      this.model = {
        first_name: '',
        middle_name:'',
        last_name: '',
        email: '',
        gender: ''
      }
      this.editMode = false
    },
    hide(){
      this.resetModel()
      this.$refs.createContactModal.hide()
    },
    async show(id = undefined){
      this.resetModel()
      if(id){
        if(id){
          await this.findContactPerson({
            id:id
          }).then(data => {
            this.editMode = true
            this.model = data.data
            this.model.id = id
          })
        }
      }
      this.$refs.createContactModal.show()
    },
  }
}
</script>

<style lang="scss">
</style>